import React from "react";

import PageContext from "../../../../contexts/PageContext";

import ProductAttribute from "./ProductAttribute";
import "./ProductAttributes.scss";
import { ActionBus } from "../../../../models/ActionBus";
import ProductInvariationDialog from "../../../../components/invariation/ProductInvariationDialog";


/**
 *
 * @param {InvariationOptions} invariationOptions
 * @param {ActionBus} actionBus
 */
export default function ProductAttributes({ attributes, product, variations, changeItem, invariationOptions, actionBus }) {
	const { currentPage } = React.useContext(PageContext);

	const searchUrl = new URL(window.location.href);
	const searchParams = searchUrl.searchParams;
	const layout = searchParams.get("layout") || currentPage.options?.layout?.details;
	const attributeBus = actionBus?.clone();

	if ([false, 'simple'].includes(layout || false)) {
		return (
			<>
				{
					attributes
						.filter(attr => !['pdf'].includes(attr.reference))
						.map((attr, key) => (
							<ProductAttribute
								attribute={attr}
								data={product[attr.reference]}
								hasImage={attr.options?.show_image}
								currentProduct={product}
								showLabel={attr.show_label}
								key={key}
								page={currentPage}
								variations={variations[attr.reference]}
								changeItem={changeItem}
								invariationOptions={invariationOptions}
								actionBus={attributeBus}
							/>
						))
				}
			</>
		);
	}
	
	// CONFIGURATOR
	const sections = {};
	attributes.forEach(attr => {
		const reference = (layout === 'configure' && variations[attr.reference]?.length > 1)
			? attr.label
			: '';

		sections[reference] = sections[reference] || [];
		sections[reference].push(attr);
	});

	const getLabel = ([attr]) => variations[attr.reference] ? attr.label : '';
	const clickLabel = e => {
		let container = e.target;
		while (container && !container.classList.contains('product-attributes')) {
			container = container.parentNode;
		}
		if (container.classList.contains('open')) {
			return container.classList.remove('open');
		}
		Array.from(container.parentNode.childNodes).map(n => n.classList.remove('open'));
		container.classList.toggle('open');

		searchParams.set('item-section', container.dataset.reference);
		window.history.pushState({}, '', `${searchUrl.pathname}${searchUrl.search}`);
	};
	const getAttribute = (attr, key) => (
		<ProductAttribute
			attribute={attr}
			data={product[attr.reference]}
			currentProduct={product}
			showLabel={attr.show_label}
			key={key}
			page={currentPage}
			variations={variations[attr.reference]}
			changeItem={changeItem}
			layout="extended"
			invariationOptions={invariationOptions}
			actionBus={attributeBus}
		/>
	);

	const getHeaderIndex = references =>
		attributes
			.filter(attr => !variations[attr.reference] && product[attr.reference])
			.find(attr => references.includes(attr.reference.toLowerCase()));

	const name = getHeaderIndex(['title', 'name', 'collection']);
	const price = getHeaderIndex(['retail_price', 'unit_price', 'cost']);

	const header = (name || price) && (
		<div className="product-attributes-header">
			<div className="name">{name && getAttribute(name, 'name')}</div>
			<div className="price">{price && getAttribute(price, 'price')}</div>
		</div>
	);

	const isSectionOverview = s => (+variations[s.at(0).reference]?.length || 0) <= 1;
	const sections_ordered = Object.values(sections);
	const overview_index = sections_ordered.findIndex(isSectionOverview);
	if (overview_index !== -1) {
		const overview = sections_ordered.splice(overview_index, 1)[0];
		sections_ordered.push(overview);
	}

	const getValue = attr => {
		return (
			<span>
				{attr.prefix ? (<span className="prefix">{attr.prefix}</span>) : ''}
				<span>{product[attr.reference]}</span>
				{attr.suffix ? (<span className="suffix">{attr.suffix}</span>) : ''}
			</span>
		);
	}
	const openSection = searchParams.get('item-section');
	const getReference = attr => attr.reference.toLowerCase().replace(/ /g, '-');
	const openIndex = Math.max(sections_ordered.findIndex(s => getReference(s.at(0)) === openSection), 0);

	const attribute_objects = sections_ordered
		.map((attr_sections, index) => (
			<section
				key={index}
				data-reference={attr_sections.at(0).reference.toLowerCase().replace(/ /g, '-')}
				className={[
					'product-attributes',
					isSectionOverview(attr_sections) && 'overview',
					(index === openIndex) && 'open'
				].filter(f => f).join(' ')}>
				{
					(layout === 'configure')
						&& !isSectionOverview(attr_sections)
						? (
							<div className="label-wrapper" onClick={clickLabel}>
								<label>{getLabel(attr_sections)}</label>
								<div className="value">
									{getValue(attr_sections.at(0))}
								</div>
							</div>
						)
						: ''
				}
				<div className="inner">{
					attr_sections
						.filter(attr => (layout !== 'configure') || ![name, price].includes(attr))
						.map(getAttribute)
				}</div>
			</section>
		));

	return (
		<>
			{header}
			<div className="attributes-grouping">{attribute_objects}</div>
		</>
	)
}
